module.exports = __webpack_public_path__ + "img/border3.95b9ad27.png";